<template>
  <div class="min-h-screen flex flex-col">
    <Header />
    <main class="flex-1 pt-[66px] md:pt-[77px]">
      <NuxtPage />
    </main>
    <Footer />
  </div>
</template>

<script setup>
import Header from "~/components/revamp/Header.vue";
import Footer from "~/components/revamp/Footer.vue";
</script>
